import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import moment from "moment";

import * as actions from "../../../../store/actions";

import PatientPrescriptionsList from "./PatientPrescriptionsList";
import SearchBox from "../../../../components/formElements/searchbox/SearchBox";
import BorderMultiSelect from "../../../../components/formElements/datepicker/BorderMultiSelect";
import Prescriptions from "../../../../pages/Dashboard/Appointments/InCall/Prescriptions";
import Modals from "../../../../components/uiElements/popupModal/modal";
import classnames from "classnames";

const PatientPrescriptions = ({
  allPrescriptions,
  searchValue,
  searchData,
  searchPatientPrescriptions,
  getPatientPrescriptions,
  patient,
  emptyPatientPrescriptions,
}) => {
  const [DateRange, setDateRange] = useState([
    moment().subtract(1, "month").toDate(),
    new Date(),
  ]);

  const [isOpen, setIsOpen] = useState(false);
  const [startDate, endDate] = DateRange;

  const adjustedEndDate = new Date(endDate);
  adjustedEndDate.setDate(adjustedEndDate.getDate() + 1);

  const ploader = useRef(null);

  const inputValue =
    startDate && endDate
      ? moment(`${startDate}`).format("MM/DD/YYYY") +
        " - " +
        moment(`${adjustedEndDate}`).format("MM/DD/YYYY")
      : "Date Range";

  useEffect(() => {
    emptyPatientPrescriptions();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    startDate &&
      endDate &&
      getPatientPrescriptions(
        patient?.dosespot_id || "17054716",
        startDate,
        endDate
      );
    //eslint-disable-next-line
  }, [endDate]);

  return (
    <>
      <Modals
        isOpen={isOpen}
        styles={{
          content: {
            minWidth: "64%",
            maxWidth: "87%",
            maxHeight: "90%",
            width: "60%",
            height: "auto",
          },
          inset: "45% auto auto 50%",
        }}
      >
        <>
          <button
            onClick={() => setIsOpen(false)}
            className="close modalCloseBtn1"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="prescritpion-view">
            <div className={classnames("note-template-container")}>
              <Prescriptions />
            </div>
          </div>
        </>
      </Modals>
      <div className="row m-3">
        <div className="col-md-5 mt-3 noteSearch">
          <SearchBox
            value={searchValue}
            onChange={q => searchPatientPrescriptions(q)}
          />
        </div>
        <div className="ml-auto px-3">
          <p
            className="mt-3"
            style={{
              cursor: "pointer",
            }}
          >
            <BorderMultiSelect
              className="border-select-input"
              startDate={startDate}
              endDate={adjustedEndDate}
              value={inputValue}
              onChange={value => setDateRange(value)}
              renderDayContents={true}
              customInput={true}
              defaultContainer={true}
            />
          </p>
        </div>
        <div>
          <button
            className="patient-add-prescriptions"
            onClick={() => setIsOpen(true)}
          >
            Add
          </button>
        </div>
      </div>

      <div
        style={{
          paddingLeft: 30,
          paddingRight: 30,
        }}
      >
        <PatientPrescriptionsList
          prescriptions={allPrescriptions}
          searchValue={searchValue}
          searchPrescriptions={searchData}
        />
      </div>
      <div ref={ploader}></div>
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation, onboarding }) => ({
  allPrescriptions: dashboard?.patients?.allPrescriptions,
  searchData: dashboard?.patients?.searchPrescriptions,
  searchValue: dashboard.patients?.searchPrescriptionValue,
  patient: dashboard?.patients?.patient,
});

const mapDispatchToProps = dispatch => ({
  getPatientFiles: () => dispatch(actions.getPatientFiles()),
  searchPatientPrescriptions: q =>
    dispatch(actions.searchPatientPrescriptions(q)),
  emptyPatientPrescriptions: () =>
    dispatch(actions.emptyPatientPrescriptions()),
  getPatientPrescriptions: (patient_id, startDate, endDate, cb) =>
    dispatch(
      actions.getPatientPrescriptions(patient_id, startDate, endDate, cb)
    ),
});

export default connect(
  mapStoreToProps,
  mapDispatchToProps
)(PatientPrescriptions);
